<template>
  <div class="bg-lightblue processing-personal-data-page">
    <header>
      <div class="container flex">
        <div class="processing-personal-data-page__logo">
          <img alt="Логотип" class="head-panel__logo" src="@/assets/img/logo/logo.png" />
          <div>Программа для стоматологических<br />клиник</div>
        </div>
        <removable-feature feature="registration">
          <router-link class="processing-personal-data-page__button" v-bind:to="{ name: 'Registration' }">Регистрация</router-link>
        </removable-feature>
      </div>
    </header>
    <main>
      <div class="container">
        <h1>Согласие на обработку персональных данных</h1>
        <div class="processing-personal-data-page__text">
          Я, в соответствии с требованиями Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных», своей волей и в своем интересе даю согласие ООО «Айкомплекс» (ОГРН 1154217003049, ИНН 4217170238), далее — Оператор, на обработку моих персональных данных, размещенных мной на интернет-сайте <a href="https://app.32top.kz">https://app.32top.kz</a> (далее — Сайт).
          <ol class="processing-personal-data-page__main-list">
            <li>
              Перечень персональных данных, на обработку которых дается согласие:
              <ul>
                <li>Фамилия, имя, отчество</li>
                <li>Адрес электронной почты</li>
                <li>Номер телефона</li>
                <li>IP-адрес</li>
                <li>Информация из cookies</li>
                <li>Информация о браузере и типе устройства</li>
                <li>Аудиозаписи разговора с сотрудниками регистратуры клиники</li>
                <li>Иные данные, указываемые мною при заполнении форм на Сайте,
                  в том числе при оставлении отзывов и других действиях.</li>
              </ul>
            </li>
            <li>
              Цели обработки персональных данных:
              <ul>
                <li>Организация записи к медицинским специалистам</li>
                <li>Обработка запросов пользователей</li>
                <li>Обеспечение обратной связи с пользователем</li>
                <li>Направление уведомлений и информационных сообщений</li>
                <li>Улучшение качества работы Сайта</li>
                <li>Проведение аналитических исследований.</li>
              </ul>
            </li>
            <li>
              Согласие даётся на следующие действия с персональными данными:
              <ul>
                <li>Сбор</li>
                <li>Запись</li>
                <li>Систематизация</li>
                <li>Накопление</li>
                <li>Хранение</li>
                <li>Уточнение (обновление, изменение)</li>
                <li>Извлечение</li>
                <li>Использование</li>
                <li>Обезличивание</li>
                <li>Блокирование</li>
                <li>Удаление</li>
                <li>Уничтожение.</li>
              </ul>
            </li>
            Обработка персональных данных может осуществляться как с использованием
            средств автоматизации, так и без их использования (неавтоматизированная обработка).
            <li>
              Передача персональных данных третьим лицам:
            </li>
            Оператор вправе передавать мои персональные данные третьим лицам
            (в том числе партнёрам и медицинским организациям), если это необходимо для достижения
            вышеуказанных целей, при условии соблюдения требований законодательства РФ в части
            обеспечения конфиденциальности и безопасности персональных данных.
            <li>
              Срок действия согласия:
              <ul>
                <li>До ликвидации ООО «Айкомплекс»</li>
                <li>До удаления сайта <a href="https://app.32top.kz">https://app.32top.kz</a></li>
                <li>До отзыва согласия на обработку персональных данных</li>
                <li>До получения требования о прекращении обработки персональных данных</li>
              </ul>
            </li>
            <p>Я уведомлен, что отзыв согласия возможен путем направления письменного уведомления
              на электронную почту Оператора:
              <a v-bind:href="$options.supportEmailHref">{{ $options.supportEmailTitle }}</a>
              либо по адресу: 654007 г. Новокузнецк, ул. Ермакова 11 , офис 5.
            </p>
            <li>Прочие условия:</li>
            Настоящее согласие может быть отозвано мной в любой момент.
            В случае отзыва согласия Оператор вправе продолжить обработку персональных данных,
            если такая обязанность предусмотрена законодательством РФ.
          </ol>
          <strong>Реквизиты оператора:</strong><br>
          ООО «Айкомплекс»<br>
          Адрес: 654007 г. Новокузнецк, ул. Ермакова 11 , офис 5<br>
          ОГРН 1154217003049<br>
          ИНН 4217170238<br>
          Email: <a v-bind:href="$options.supportEmailHref">{{ $options.supportEmailTitle }}</a><br>
        </div>
      </div>
      <footer>
        <div class="container flex">
          <div>2008-{{ currentYear }}© mis.32top.kz</div>
          <router-link class="processing-personal-data-page__link" v-bind:to="{ name: 'ProcessingPersonalData' }">
            Согласие на обработку персональных данных
          </router-link>
        </div>
      </footer>
    </main>
  </div>
</template>
<script>
import RemovableFeature from '@/components/RemovableFeature.vue';
import aboutMixin from '@/mixins/aboutMixin';

/**
 * @description Компонент политики конфиденциальности.
 */
export default {
  components: {
    RemovableFeature,
  },
  data() {
    return {
      currentYear: (new Date()).getFullYear(),
    };
  },
  mixins: [
    aboutMixin,
  ],
  name: 'ProcessingPersonalData',
};
</script>
<style scoped lang="scss">
@use "@/scss/buttons";

main {
  flex: 1;
  overflow-y: auto;
}

.bg-lightblue {
  background: linear-gradient(180deg, #e2f8ff 53.71%, rgba(213, 237, 255, 0) 100%);
}

.processing-personal-data-page {
  height: 100vh;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  header {
    padding: 8px 0;
    border-bottom: 1px solid rgba(0, 163, 255, 0.2);
  }

  &__link,
  footer > div {
    color: #000 !important;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  &__link:hover {
    text-decoration: none;
  }

  &__logo {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 16px;
    color: rgba(40, 49, 67, 0.7);
    gap: 25px;
  }

  &__main-list {
    display: grid;
    row-gap: 10px;
  }

  &__list-title {
    font-weight: 600;
  }

  &__text {
    margin: 10px;
  }

  &__button {
    @include buttons.btn-blue(160px, 40px, 16px);
    color: white !important;
    text-decoration: none;
  }

  h1 {
    font-weight: 700;
    font-size: 45px;
    line-height: 59px;
    margin-bottom: 50px;
}

  h2 {
    font-weight: 500;
  }

  p {
    display: block;
    margin-block: 15px !important;
  }

  ul {
    margin: 20px 0;
    padding-left: 0;
    overflow-wrap: anywhere;
    > li {
      position: relative;
      margin-block: 10px;
      padding-left: 30px;
      list-style-type: none;
      &::before {
        content: "";
        position: absolute;
        top: .7em;
        left: 0;
        width: 10px;
        height: 10px;
        background: #00a3ff;
        border-radius: 50%;
        transform: translateY(-50%);
      }
    }
  }

  ol {
    margin: 20px 0;
    padding-left: 30px;
    counter-reset: li;
    overflow-wrap: anywhere;
    > li {
      padding-left: 10px;
      counter-increment: li;
      &::marker {
        content: counters(li, ".") ". ";
        font-size: 1.5em;
        font-weight: 600;
        color: #00a3ff;
      }
    }
  }

  footer {
    border-top: 1px solid #bfdaec;
    padding: 16px 0;
  }

  footer > .flex {
    max-width: 600px;
  }
}

.flex {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}

@media screen and (max-width: 986px) {
  .processing-personal-data-page {
    h1 {
      font-size: 38px;
      line-height: 48px;
    }
  }
}

@media screen and (max-width: 768px) {
  .processing-personal-data-page {
    h1 {
      font-size: 26px !important;
      line-height: 30px !important;
      margin-bottom: 25px;
    }
  }
}

@media screen and (max-width: 600px) {
  .processing-personal-data-page {
    &__logo > div {
      display: none;
    }
  }
  footer > .flex {
    flex-direction: column;
    align-items: start;
    gap: 5px;
  }
}

@media screen and (max-width: 400px) {
  .processing-personal-data-page {
    h2 {
      font-size: 22px;
      line-height: normal;
    }
    ol {
      font-size: 14px;
      > li::marker {
        font-size: 22px;
      }
    }
  }
}
</style>
